// Generated by scripts/build-canonical.ts from src/data/source/*.json.
// Do not edit by hand — re-run the script to refresh. This is schema v2 (canonical items
// catalog) — it coexists with the legacy per-category files, it does not replace them yet.

import { CANONICAL_NPCS, CANONICAL_SHOPS, CANONICAL_LOCATIONS } from "./entities";
import type { ShopListingRef } from "../schema/types";

export const NPCS_BY_ID: Record<string, (typeof CANONICAL_NPCS)[number]> =
  Object.fromEntries(CANONICAL_NPCS.map((npc) => [npc.id, npc]));

export const SHOPS_BY_ID: Record<string, (typeof CANONICAL_SHOPS)[number]> =
  Object.fromEntries(CANONICAL_SHOPS.map((shop) => [shop.id, shop]));

export const LOCATIONS_BY_ID: Record<string, (typeof CANONICAL_LOCATIONS)[number]> =
  Object.fromEntries(CANONICAL_LOCATIONS.map((location) => [location.id, location]));

export const SHOPS_BY_NPC_ID: Record<string, string[]> = {
  "andrew": [
    "shop-andrew"
  ],
  "annie": [
    "shop-annie"
  ],
  "bailey-j": [
    "shop-bailey-j"
  ],
  "blanc": [
    "shop-blanc"
  ],
  "bob": [
    "shop-bob"
  ],
  "collector": [
    "shop-collector"
  ],
  "doris": [
    "shop-doris"
  ],
  "dorothee": [
    "shop-dorothee"
  ],
  "ka-ching": [
    "shop-ka-ching"
  ],
  "massimo": [
    "shop-massimo"
  ],
  "mrs-joan": [
    "shop-mrs-joan"
  ],
  "naniwa": [
    "shop-naniwa"
  ],
  "vanya": [
    "shop-vanya"
  ]
};

export const SHOPS_BY_LOCATION_ID: Record<string, string[]> = {
  "central-square": [
    "shop-andrew",
    "shop-annie",
    "shop-bailey-j",
    "shop-bob",
    "shop-collector",
    "shop-dorothee",
    "shop-ka-ching",
    "shop-mrs-joan",
    "shop-naniwa",
    "shop-vanya"
  ],
  "garden-street": [
    "shop-blanc"
  ],
  "art-street": [
    "shop-doris",
    "shop-massimo"
  ]
};

export const SHOP_LISTINGS_BY_SHOP_ID: Record<string, ShopListingRef[]> = {
  "shop-andrew": [
    {
      "id": "shop-andrew-listing-0",
      "shopId": "shop-andrew",
      "itemId": "black-motorcycle",
      "price": 80000,
      "currency": "GOLD"
    },
    {
      "id": "shop-andrew-listing-1",
      "shopId": "shop-andrew",
      "itemId": "black-sedan",
      "price": 600000,
      "currency": "GOLD"
    },
    {
      "id": "shop-andrew-listing-2",
      "shopId": "shop-andrew",
      "itemId": "blue-sedan",
      "price": 600000,
      "currency": "GOLD"
    },
    {
      "id": "shop-andrew-listing-3",
      "shopId": "shop-andrew",
      "itemId": "green-motorcycle",
      "price": 0,
      "currency": "GOLD"
    },
    {
      "id": "shop-andrew-listing-4",
      "shopId": "shop-andrew",
      "itemId": "pink-motorcycle",
      "price": 80000,
      "currency": "GOLD"
    },
    {
      "id": "shop-andrew-listing-5",
      "shopId": "shop-andrew",
      "itemId": "pink-sedan",
      "price": 300,
      "currency": "WISHING_STARS"
    },
    {
      "id": "shop-andrew-listing-6",
      "shopId": "shop-andrew",
      "itemId": "red-motorcycle",
      "price": 80000,
      "currency": "GOLD"
    },
    {
      "id": "shop-andrew-listing-7",
      "shopId": "shop-andrew",
      "itemId": "simplistic-mountain-bike",
      "price": 48,
      "currency": "WISHING_STARS"
    },
    {
      "id": "shop-andrew-listing-8",
      "shopId": "shop-andrew",
      "itemId": "white-convertible",
      "price": 750,
      "currency": "WISHING_STARS"
    },
    {
      "id": "shop-andrew-listing-9",
      "shopId": "shop-andrew",
      "itemId": "white-motorcycle",
      "price": 80000,
      "currency": "GOLD"
    },
    {
      "id": "shop-andrew-listing-10",
      "shopId": "shop-andrew",
      "itemId": "yellow-sedan",
      "price": 300,
      "currency": "WISHING_STARS"
    }
  ],
  "shop-blanc": [
    {
      "id": "shop-blanc-listing-0",
      "shopId": "shop-blanc",
      "itemId": "anthurium-seeds",
      "price": 60,
      "currency": "GOLD"
    },
    {
      "id": "shop-blanc-listing-1",
      "shopId": "shop-blanc",
      "itemId": "calla-lily-seeds",
      "price": 90,
      "currency": "GOLD"
    },
    {
      "id": "shop-blanc-listing-2",
      "shopId": "shop-blanc",
      "itemId": "carnation-seeds",
      "price": 120,
      "currency": "GOLD"
    },
    {
      "id": "shop-blanc-listing-3",
      "shopId": "shop-blanc",
      "itemId": "corn-poppy-seeds",
      "price": 60,
      "currency": "GOLD"
    },
    {
      "id": "shop-blanc-listing-4",
      "shopId": "shop-blanc",
      "itemId": "cranesbill-seeds",
      "price": 300,
      "currency": "GOLD"
    },
    {
      "id": "shop-blanc-listing-5",
      "shopId": "shop-blanc",
      "itemId": "daisy-seeds",
      "price": 30,
      "currency": "GOLD"
    },
    {
      "id": "shop-blanc-listing-6",
      "shopId": "shop-blanc",
      "itemId": "hyacinth-seeds",
      "price": 300,
      "currency": "GOLD"
    },
    {
      "id": "shop-blanc-listing-7",
      "shopId": "shop-blanc",
      "itemId": "laceleaf-seeds",
      "price": 60,
      "currency": "GOLD"
    },
    {
      "id": "shop-blanc-listing-8",
      "shopId": "shop-blanc",
      "itemId": "lily-seeds",
      "price": 200,
      "currency": "GOLD"
    },
    {
      "id": "shop-blanc-listing-9",
      "shopId": "shop-blanc",
      "itemId": "morning-glory-seeds",
      "price": 90,
      "currency": "GOLD"
    },
    {
      "id": "shop-blanc-listing-10",
      "shopId": "shop-blanc",
      "itemId": "moth-orchid-seeds",
      "price": 300,
      "currency": "GOLD"
    },
    {
      "id": "shop-blanc-listing-11",
      "shopId": "shop-blanc",
      "itemId": "pansy-seeds",
      "price": 30,
      "currency": "GOLD"
    },
    {
      "id": "shop-blanc-listing-12",
      "shopId": "shop-blanc",
      "itemId": "romaine-lettuce-seed",
      "price": 10,
      "currency": "GOLD"
    },
    {
      "id": "shop-blanc-listing-13",
      "shopId": "shop-blanc",
      "itemId": "rose-seeds",
      "price": 300,
      "currency": "GOLD"
    },
    {
      "id": "shop-blanc-listing-14",
      "shopId": "shop-blanc",
      "itemId": "tulip-seeds",
      "price": 150,
      "currency": "GOLD"
    },
    {
      "id": "shop-blanc-listing-15",
      "shopId": "shop-blanc",
      "itemId": "avocado-seed",
      "price": 180,
      "currency": "GOLD"
    },
    {
      "id": "shop-blanc-listing-16",
      "shopId": "shop-blanc",
      "itemId": "cacao-seed",
      "price": 110,
      "currency": "GOLD"
    },
    {
      "id": "shop-blanc-listing-17",
      "shopId": "shop-blanc",
      "itemId": "carrot-seed",
      "price": 50,
      "currency": "GOLD"
    },
    {
      "id": "shop-blanc-listing-18",
      "shopId": "shop-blanc",
      "itemId": "corn-seed",
      "price": 170,
      "currency": "GOLD"
    },
    {
      "id": "shop-blanc-listing-19",
      "shopId": "shop-blanc",
      "itemId": "eggplant-seed",
      "price": 135,
      "currency": "GOLD"
    },
    {
      "id": "shop-blanc-listing-20",
      "shopId": "shop-blanc",
      "itemId": "fertilizer",
      "price": 160,
      "currency": "GOLD"
    },
    {
      "id": "shop-blanc-listing-21",
      "shopId": "shop-blanc",
      "itemId": "grape-seed",
      "price": 160,
      "currency": "GOLD"
    },
    {
      "id": "shop-blanc-listing-22",
      "shopId": "shop-blanc",
      "itemId": "growth-booster",
      "price": 50,
      "currency": "GOLD"
    },
    {
      "id": "shop-blanc-listing-23",
      "shopId": "shop-blanc",
      "itemId": "lettuce-seed",
      "price": 145,
      "currency": "GOLD"
    },
    {
      "id": "shop-blanc-listing-24",
      "shopId": "shop-blanc",
      "itemId": "pineapple-seed",
      "price": 15,
      "currency": "GOLD"
    },
    {
      "id": "shop-blanc-listing-25",
      "shopId": "shop-blanc",
      "itemId": "potato-seed",
      "price": 30,
      "currency": "GOLD"
    },
    {
      "id": "shop-blanc-listing-26",
      "shopId": "shop-blanc",
      "itemId": "strawberry-seed",
      "price": 125,
      "currency": "GOLD"
    },
    {
      "id": "shop-blanc-listing-27",
      "shopId": "shop-blanc",
      "itemId": "tomato-seed",
      "price": 10,
      "currency": "GOLD"
    },
    {
      "id": "shop-blanc-listing-28",
      "shopId": "shop-blanc",
      "itemId": "wheat-seed",
      "price": 95,
      "currency": "GOLD"
    }
  ],
  "shop-doris": [
    {
      "id": "shop-doris-listing-0",
      "shopId": "shop-doris",
      "itemId": "blue-sugar",
      "price": 150,
      "currency": "GOLD"
    },
    {
      "id": "shop-doris-listing-1",
      "shopId": "shop-doris",
      "itemId": "green-sugar",
      "price": 200,
      "currency": "GOLD"
    },
    {
      "id": "shop-doris-listing-2",
      "shopId": "shop-doris",
      "itemId": "indigo-sugar",
      "price": 150,
      "currency": "GOLD"
    },
    {
      "id": "shop-doris-listing-3",
      "shopId": "shop-doris",
      "itemId": "orange-sugar",
      "price": 200,
      "currency": "GOLD"
    },
    {
      "id": "shop-doris-listing-4",
      "shopId": "shop-doris",
      "itemId": "red-sugar",
      "price": 200,
      "currency": "GOLD"
    },
    {
      "id": "shop-doris-listing-5",
      "shopId": "shop-doris",
      "itemId": "sugar",
      "price": 150,
      "currency": "GOLD"
    },
    {
      "id": "shop-doris-listing-6",
      "shopId": "shop-doris",
      "itemId": "violet-sugar",
      "price": 150,
      "currency": "GOLD"
    },
    {
      "id": "shop-doris-listing-7",
      "shopId": "shop-doris",
      "itemId": "yellow-sugar",
      "price": 200,
      "currency": "GOLD"
    }
  ],
  "shop-massimo": [
    {
      "id": "shop-massimo-listing-0",
      "shopId": "shop-massimo",
      "itemId": "butter",
      "price": 150,
      "currency": "GOLD"
    },
    {
      "id": "shop-massimo-listing-1",
      "shopId": "shop-massimo",
      "itemId": "cheese",
      "price": 100,
      "currency": "GOLD"
    },
    {
      "id": "shop-massimo-listing-2",
      "shopId": "shop-massimo",
      "itemId": "coffee-beans",
      "price": 50,
      "currency": "GOLD"
    },
    {
      "id": "shop-massimo-listing-3",
      "shopId": "shop-massimo",
      "itemId": "egg",
      "price": 100,
      "currency": "GOLD"
    },
    {
      "id": "shop-massimo-listing-4",
      "shopId": "shop-massimo",
      "itemId": "milk",
      "price": 50,
      "currency": "GOLD"
    },
    {
      "id": "shop-massimo-listing-5",
      "shopId": "shop-massimo",
      "itemId": "salsa-sauce",
      "price": 50,
      "currency": "GOLD"
    },
    {
      "id": "shop-massimo-listing-6",
      "shopId": "shop-massimo",
      "itemId": "springday-brown-sugar",
      "price": 50,
      "currency": "GOLD"
    },
    {
      "id": "shop-massimo-listing-7",
      "shopId": "shop-massimo",
      "itemId": "amazing-seasoning",
      "price": 3000,
      "currency": "GOLD"
    },
    {
      "id": "shop-massimo-listing-8",
      "shopId": "shop-massimo",
      "itemId": "cooking-oil",
      "price": 100,
      "currency": "GOLD"
    },
    {
      "id": "shop-massimo-listing-9",
      "shopId": "shop-massimo",
      "itemId": "frosted",
      "price": 50,
      "currency": "GOLD"
    },
    {
      "id": "shop-massimo-listing-10",
      "shopId": "shop-massimo",
      "itemId": "matcha-powder",
      "price": 250,
      "currency": "GOLD"
    },
    {
      "id": "shop-massimo-listing-11",
      "shopId": "shop-massimo",
      "itemId": "meat",
      "price": 200,
      "currency": "GOLD"
    },
    {
      "id": "shop-massimo-listing-12",
      "shopId": "shop-massimo",
      "itemId": "pasteurized-egg",
      "price": 100,
      "currency": "GOLD"
    },
    {
      "id": "shop-massimo-listing-13",
      "shopId": "shop-massimo",
      "itemId": "red-bean",
      "price": 50,
      "currency": "GOLD"
    },
    {
      "id": "shop-massimo-listing-14",
      "shopId": "shop-massimo",
      "itemId": "rice-flour",
      "price": 50,
      "currency": "GOLD"
    },
    {
      "id": "shop-massimo-listing-15",
      "shopId": "shop-massimo",
      "itemId": "tea-leaves",
      "price": 250,
      "currency": "GOLD"
    },
    {
      "id": "shop-massimo-listing-16",
      "shopId": "shop-massimo",
      "itemId": "universal-ingredient",
      "price": 2000,
      "currency": "GOLD"
    }
  ],
  "shop-mrs-joan": [
    {
      "id": "shop-mrs-joan-listing-0",
      "shopId": "shop-mrs-joan",
      "itemId": "cat-food",
      "price": 150,
      "currency": "GOLD"
    },
    {
      "id": "shop-mrs-joan-listing-1",
      "shopId": "shop-mrs-joan",
      "itemId": "dog-food",
      "price": 150,
      "currency": "GOLD"
    },
    {
      "id": "shop-mrs-joan-listing-2",
      "shopId": "shop-mrs-joan",
      "itemId": "universal-animal-food",
      "price": 150,
      "currency": "GOLD"
    }
  ],
  "shop-naniwa": [
    {
      "id": "shop-naniwa-listing-0",
      "shopId": "shop-naniwa",
      "itemId": "inflatable-insect-attractor",
      "price": 2000,
      "currency": "GOLD"
    },
    {
      "id": "shop-naniwa-listing-1",
      "shopId": "shop-naniwa",
      "itemId": "large-vivarium",
      "price": 200,
      "currency": "WISHING_STARS"
    },
    {
      "id": "shop-naniwa-listing-2",
      "shopId": "shop-naniwa",
      "itemId": "medium-vivarium",
      "price": 98000,
      "currency": "GOLD"
    },
    {
      "id": "shop-naniwa-listing-3",
      "shopId": "shop-naniwa",
      "itemId": "sense-booster",
      "price": 4000,
      "currency": "GOLD"
    },
    {
      "id": "shop-naniwa-listing-4",
      "shopId": "shop-naniwa",
      "itemId": "small-vivarium",
      "price": 34000,
      "currency": "GOLD"
    }
  ]
};

export const LOCATIONS_BY_REGION: Record<string, string[]> = {
  "Town": [
    "art-street",
    "central-square",
    "garden-street",
    "home-plots",
    "residential-street",
    "suburban-lake",
    "suburban-lake-2",
    "suburbs"
  ],
  "Nature": [
    "crater-lake",
    "giant-wood-river",
    "meadow-lake",
    "rosy-river",
    "shallow-river",
    "tranquil-river",
    "windmill-flower-field"
  ],
  "Adventure": [
    "deer-tower",
    "jump-puzzle",
    "ruins",
    "stone-cliff"
  ],
  "Coast": [
    "east-pier-fishing-village",
    "lighthouse",
    "wharf"
  ],
  "Sea": [
    "east-sea",
    "old-sea",
    "whale-sea",
    "zephyr-sea"
  ],
  "Fishing Village": [
    "fishing_village",
    "fishing-village-square"
  ],
  "Forest": [
    "forest-island",
    "forest-lake",
    "spirit-oak-pine-forest"
  ],
  "Mountain": [
    "hot-spring-mountain",
    "onsen-mountain",
    "onsen-mountain-lake",
    "whale-mountain"
  ],
  "Beach": [
    "purple-light-beach"
  ]
};
